<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: ["MESES", "MB", "EMV", "CMVMC"],
  mounted() {
    this.renderChart(
      {
        labels: this.MESES,
        datasets: [
          {
            label: "Margem Bruta",
            borderColor: "rgb(255, 141, 165)",
            pointBackgroundColor: "rgb(255, 141, 165)",
            type: "line",
            fill: false,
            lineTension: 0,
            data: this.MB
          },
          {
            label: "Prestações de serviços",
            backgroundColor: "rgb(113, 206, 206, 0.5)",
            borderColor: "rgb(113, 206, 206, 1)",
            borderWidth: 1,
            data: this.EMV
          },
          {
            label: "CMVMC ou Compras",
            backgroundColor: "rgb(255, 185, 115, 0.5)",
            borderColor: "rgb(255, 185, 115, 1)",
            borderWidth: 1,
            data: this.CMVMC
          }
        ]
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: "Evolução mensal das Vendas, CMVMC ou Compras e Margem Bruta",
          fontSize: 14
        },
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Valores em €"
              },
              ticks: {
                beginAtZero: true
              }
            }
          ]
        }
      }
    );
  }
};
</script>



// WEBPACK FOOTER //
// src/components/charts/Chart1.vue